module.exports = __webpack_public_path__ + "img/icon-slider-03-academy-template.f9572b77.svg";